<template>
  <section class="section-two bg-light mt-5 mb-2">
    <NoResult v-if="schedule.professional == null"/>

    <div class="container-fluid" v-else>
      <div class="row m-3">

        <div class="col-lg-3 mb-4 order-2 order-sm-1 order-md-1">
          <MenuAction/>
        </div>

        <div class="col-lg-9 order-1 order-sm-2 order-md-2">

          <div class="row">

            <div :class="paymentMethod?.is_credit_card ? 'col-md-12' : 'col-md-10 offset-md-1'">
              <div class="alert alert-danger" role="alert" v-if="msgErrorSchedule">
                {{ msgErrorSchedule }}
              </div>
            </div>

            <div class="col-md-6" v-if="paymentMethod?.is_credit_card">
              <SavedCreditCardList 
                v-if="showSavedCards && savedCreditCards.length > 0"
                :saved-cards="savedCreditCards"
                :selected-card-id="selectedCreditCardId"
                @card-selected="onCardSelected"
                @show-new-card="showNewCardForm"
              />

              <div v-if="!showSavedCards || savedCreditCards.length === 0">
                <CreditCardMP :booking="schedule" @onSubmit="onSubmitFormCreditCard"
                              v-if="cancelingPolicy.card_administrator_code == 'MP'">
                  <template #saveCardOptions v-if="cancelingPolicy?.supports_tokenization">
                    <div class="row mt-3" v-if="!selectedCreditCardId">
                      <div class="col-md-12">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="checkbox" id="saveCard" v-model="saveCard">
                          <label class="form-check-label" for="saveCard">
                            Salvar cartão para próximos pagamentos
                          </label>
                        </div>
                        <div v-if="saveCard" class="mb-3">
                          <label class="form-label" for="cardNickname">Apelido do cartão (opcional):</label>
                          <input type="text" class="form-control" id="cardNickname" 
                                 v-model="cardNickname" 
                                 placeholder="Ex: Cartão principal"
                                 maxlength="50">
                        </div>
                      </div>
                    </div>
                  </template>
                </CreditCardMP>

                <CreditCardGN :booking="schedule" @onSubmit="onSubmitFormCreditCard"
                              v-else-if="cancelingPolicy.card_administrator_code == 'GN'">
                  <template #saveCardOptions v-if="cancelingPolicy?.supports_tokenization">
                    <div class="row mt-3" v-if="!selectedCreditCardId">
                      <div class="col-md-12">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="checkbox" id="saveCard" v-model="saveCard">
                          <label class="form-check-label" for="saveCard">
                            Salvar cartão para próximos pagamentos
                          </label>
                        </div>
                        <div v-if="saveCard" class="mb-3">
                          <label class="form-label" for="cardNickname">Apelido do cartão (opcional):</label>
                          <input type="text" class="form-control" id="cardNickname" 
                                 v-model="cardNickname" 
                                 placeholder="Ex: Cartão principal"
                                 maxlength="50">
                        </div>
                      </div>
                    </div>
                  </template>
                </CreditCardGN>

                <CreditCardEF :booking="schedule" @onSubmit="onSubmitFormCreditCard"
                              v-else-if="cancelingPolicy.card_administrator_code == 'EF'">
                  <template #saveCardOptions v-if="cancelingPolicy?.supports_tokenization">
                    <div class="row mt-3" v-if="!selectedCreditCardId">
                      <div class="col-md-12">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="checkbox" id="saveCard" v-model="saveCard">
                          <label class="form-check-label" for="saveCard">
                            Salvar cartão para próximos pagamentos
                          </label>
                        </div>
                        <div v-if="saveCard" class="mb-3">
                          <label class="form-label" for="cardNickname">Apelido do cartão (opcional):</label>
                          <input type="text" class="form-control" id="cardNickname" 
                                 v-model="cardNickname" 
                                 placeholder="Ex: Cartão principal"
                                 maxlength="50">
                        </div>
                      </div>
                    </div>
                  </template>
                </CreditCardEF>

                <CreditCardAS :booking="schedule" @onSubmit="onSubmitFormCreditCard"
                              v-else-if="cancelingPolicy.card_administrator_code == 'AS'">
                  <template #saveCardOptions v-if="cancelingPolicy?.supports_tokenization">
                    <div class="row mt-3" v-if="!selectedCreditCardId">
                      <div class="col-md-12">
                        <div class="form-check mb-2">
                          <input class="form-check-input" type="checkbox" id="saveCard" v-model="saveCard">
                          <label class="form-check-label" for="saveCard">
                            Salvar cartão para próximos pagamentos
                          </label>
                        </div>
                        <div v-if="saveCard" class="mb-3">
                          <label class="form-label" for="cardNickname">Apelido do cartão (opcional):</label>
                          <input type="text" class="form-control" id="cardNickname" 
                                 v-model="cardNickname" 
                                 placeholder="Ex: Cartão principal"
                                 maxlength="50">
                        </div>
                      </div>
                    </div>
                  </template>
                </CreditCardAS>

                <div v-else class="text-center">
                  <h3>Falha ao carregar dados, tente novamente</h3>
                  <a class="btn btn-primary" :href="$route.fullPath">
                    Tentar novamente
                  </a>
                </div>
              </div>
            </div>

            <DocumentUpload 
              v-if="paymentMethod?.is_insurance" 
              :schedule="schedule"
              :spec-group="null"
              @documents-changed="onDocumentsChanged"
              @has-required-documents="onHasRequiredDocuments"
              ref="documentUpload"
              v-show="showDocumentUpload"
            />

            <div :class="paymentMethod?.is_credit_card || (paymentMethod?.is_insurance && showDocumentUpload) ? 'col-md-6' : 'col-md-10 offset-md-1'" class="mb-3">
              <div class="rounded shadow-lg p-4 sticky-bar" v-if="professional">
                <div class="d-flex mb-0 justify-content-between">
                  <h5>Confirme os dados</h5>
                </div>
                <div class="table-responsive">
                  <table class="table table-center table-padding mb-0">
                    <tbody>
                    <tr>
                      <td colspan="12" class="pb-0">
                        <p class="h6">Profissional: </p>
                        <p class="fw-bold pb-0">{{ professional.prof_name }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="12" class="pb-0">
                        <p class="h6">Local: </p>
                        <p class="fw-bold pb-0">{{ displayPlaceName }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="12" class="pb-0">
                        <p class="h6">Endereço: </p>
                        <p class="fw-bold pb-0">{{ displayAddress }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="12" class="pb-0">
                        <p class="h6">Data: </p>
                        <p class="fw-bold pb-0">
                          {{ date(availability.available_date_patient).format('DD MMM YYYY - dddd') }} às
                          {{ availability.available_time_patient }}h
                        </p>
                      </td>
                    </tr>
                    <tr class="bg-light" v-if="cancelingPolicy">
                      <td colspan="12" class="pb-0">
                        <p class="h6">Valor: </p>
                        <p class="text-primary pb-0 h5 fw-bold">R$ {{ cancelingPolicy.value }}</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <div class="col-md-12" v-if="schedule.availabilityTime.avail_online">
                    <br>
                    <div class="mb-3">
                      <div class="form-check">
                        <label class="form-check-label" for="flexCheckDefault">
                          Ao agendar você concorda com
                          <a target="_blank" href="https://policies.ubbimed.com.br/term-telemedicine.php"
                             class="text-primary">
                            Termos da teleconsulta.
                          </a>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 pt-2" v-if="!paymentMethod?.is_credit_card">
                    <div class="d-grid">
                      <button class="btn btn-primary" type="button" @click="scheduleAppointment">
                        Agendar consulta
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" id="modalAddress" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static"
           aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <form @submit.prevent="scheduleAppointment">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Confirme o seu endereço</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="address_cep" class="form-label required">
                        CEP <i class="text-danger">*</i>
                      </label>
                      <input type="text" class="form-control" id="address_cep"
                             @change="getZipCode($event.target.value)" required
                             v-model="userAddress.user_addr_zipcode">
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="mb-3">
                      <label for="address" class="form-label required">
                        Endereço <i class="text-danger">*</i>
                      </label>
                      <input type="text" class="form-control" id="address" required
                             v-model="userAddress.user_address">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="address_nro" class="form-label required">
                        Número <i class="text-danger">*</i>
                      </label>
                      <input type="text" class="form-control" id="address_nro" required
                             v-model="userAddress.user_addr_numer">
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="mb-3">
                      <label for="address_neighbourhood" class="form-label required">
                        Bairro <i class="text-danger">*</i>
                      </label>
                      <input type="text" class="form-control" id="address_neighbourhood" required
                             v-model="userAddress.user_neighborhood">
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label for="address_complement" class="form-label">
                        Complemento
                      </label>
                      <input type="text" class="form-control" id="address_complement"
                             v-model="userAddress.user_addr_compl">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="address_stage" class="form-label">
                        Estado <i class="text-danger">*</i>
                      </label>
                      <InputSelect :required="true"
                                   id="address_stage"
                                   label="state_name"
                                   @change="getCitiesFromState($event)"
                                   value="id_state"
                                   :options="states"
                                   v-model="userAddress.id_state"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="address_city" class="form-label">
                        Cidade <i class="text-danger">*</i>
                      </label>
                      <InputSelect id="address_city" :required="true"
                                   label="city_name"
                                   value="id_city"
                                   :options="citiesFromState"
                                   v-model="userAddress.id_city"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <div class="col-md-12">
                  <div class="d-grid">
                    <button type="submit" class="btn btn-primary">
                      Agendar consulta
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import MenuAction from './MenuAction.vue'
import CreditCardMP from '../toSchedule/gateways/CreditCardMP.vue'
import CreditCardGN from "../toSchedule/gateways/CreditCardGN.vue";
import CreditCardAS from "../toSchedule/gateways/CreditCardAS.vue";
import date from "@/helpers/date";
import {mask} from 'vue-the-mask';
import Alert from "../../helpers/alert";
import Swal from "sweetalert2";
import NoResult from "../toSchedule/NoResult.vue";
import InputSelect from "../components/InputSelect.vue";
import http from "../../helpers/http";
import CreditCardEF from "../toSchedule/gateways/CreditCardEF.vue";
import DocumentUpload from "../toSchedule/components/DocumentUpload.vue";
import SavedCreditCardList from "../toSchedule/components/SavedCreditCardList.vue";
import { profileTo } from "./paths";

export default {
  name: 'Payment',
  components: {
    CreditCardEF,
    InputSelect,
    CreditCardGN,
    MenuAction,
    CreditCardMP,
    CreditCardAS,
    NoResult,
    DocumentUpload,
    SavedCreditCardList,
  },
  directives: {
    mask,
  },
  data() {
    return {
      msgErrorSchedule: '',
      creditCard: null,
      states: null,
      citiesFromState: null,
      uploadedDocuments: [],
      showDocumentUpload: false,
      placeLocation: null,
      selectedCreditCardId: null,
      saveCard: false,
      cardNickname: '',
      showSavedCards: true,
      userAddress: {
        user_address: null,
        user_addr_zipcode: null,
        user_addr_numer: null,
        user_addr_compl: null,
        user_neighborhood: null,
        id_city: null,
        id_state: null,
      },
    };
  },
  mounted() {
    this.getStates();

    this.userAddress = {
      user_address: this.userAuth.user_address,
      user_addr_zipcode: this.userAuth.user_addr_zipcode,
      user_addr_numer: this.userAuth.user_addr_numer,
      user_addr_compl: this.userAuth.user_addr_compl,
      user_neighborhood: this.userAuth.user_neighborhood,
      id_city: this.userAuth.id_city,
      id_state: this.userAuth.id_state,
    };

    if (this.userAuth.id_state) {
      this.getCitiesFromState(this.userAuth.id_state);
    }

    this.loadPlaceLocation();

    if (this.paymentMethod?.is_credit_card && this.userAuth?.id_user && this.cancelingPolicy?.card_administrator_code) {
      this.$store.dispatch('professionalProfile/getSavedCreditCards', this.cancelingPolicy.card_administrator_code).then(() => {
        if (this.savedCreditCards.length === 0) {
          this.showSavedCards = false;
        }
      });
    }
  },
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    },
    schedule() {
      return this.$store.state.professionalProfile.schedule;
    },
    paymentMethod() {
      return this.$store.state.professionalProfile.schedule.paymentMethod;
    },
    professional() {
      return this.$store.state.professionalProfile.schedule.professional;
    },
    availability() {
      return this.$store.state.professionalProfile.schedule.availabilityTime;
    },
    cancelingPolicy() {
      return this.$store.state.professionalProfile.schedule.cancelingPolicy;
    },
    displayAddress() {
      if (this.placeLocation) {
        const address = this.placeLocation.location_address || '';
        const number = this.placeLocation.location_addr_numer || '';
        const neighborhood = this.placeLocation.location_neighborhood || '';
        const cityName = this.placeLocation.city?.city_name || '';
        const stateInitials = this.placeLocation.city?.state?.state_initials || this.placeLocation.state?.state_initials || '';
        const parts = [address];
        if (number) parts.push(number);
        if (neighborhood) parts.push(neighborhood);
        const addressPart = parts.join(', ');
        const locationPart = cityName || stateInitials ? ` - ${cityName}${stateInitials ? '/' + stateInitials : ''}` : '';
        return `${addressPart}${locationPart}`.trim();
      }
      return `${this.professional?.place_address || ''}, ${this.professional?.place_addr_numer || ''} ${this.professional?.place_neighborhood || ''} - ${this.professional?.city_name || ''}/${this.professional?.state_initials || ''}`.trim();
    },
    displayPlaceName() {
      if (this.placeLocation) {
        return this.placeLocation.location_name || this.professional?.place_name;
      }
      return this.professional?.place_name;
    },
    savedCreditCards() {
      return this.$store.state.professionalProfile.savedCreditCards;
    },
  },
  methods: {
    date: date,
    getStates() {
      http.get(`/states`).then((response) => {
        this.states = response.data;
      });
    },
    getCitiesFromState(stateId) {
      return http.get(`/states/${stateId}/cities`).then((response) => {
        this.citiesFromState = response.data;

        return response;
      });
    },
    loadPlaceLocation() {
      if (this.availability?.id_place_location && this.professional?.id_place) {
        http.get(`/places/${this.professional.id_place}/locations/${this.availability.id_place_location}`).then((response) => {
          this.placeLocation = response.data;
        }).catch(() => {
          this.placeLocation = null;
        });
      }
    },
    getZipCode(zipCode) {
      http.get(`/zipcode/${zipCode}`).then((response) => {
        let data = response.data;
        this.userAddress.user_address = data.address;
        this.userAddress.user_neighborhood = data.neighborhood;
        let state = data.state;
        this.userAddress.id_state = state?.id_state;
        this.getCitiesFromState(state?.id_state);
        this.userAddress.id_city = data.city?.id_city;
      });
    },
    onCardSelected(card) {
      this.selectedCreditCardId = card.id;
      this.creditCard = null;
      this.saveCard = false;
      this.cardNickname = '';
      
      let modal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#modalAddress'));
      modal.toggle();
    },
    showNewCardForm() {
      this.selectedCreditCardId = null;
      this.showSavedCards = false;
    },
    onSubmitFormCreditCard(creditCard) {
      this.creditCard = creditCard;
      this.selectedCreditCardId = null;

      let modal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#modalAddress'));
      modal.toggle();
    },
    onDocumentsChanged(documents) {
      this.uploadedDocuments = documents;
    },
    onHasRequiredDocuments(hasDocuments) {
      this.showDocumentUpload = hasDocuments;
    },
    scheduleAppointment() {
      this.msgErrorSchedule = '';
      
      if (this.paymentMethod.is_credit_card && !this.creditCard && !this.selectedCreditCardId) {
        Alert.error('Falha ao processar os dados do cartão de crédito - Verifique sua conexão e tente novamente.');
        return;
      }

      if (this.paymentMethod.is_insurance && this.$refs.documentUpload) {
        if (!this.$refs.documentUpload.validateAllDocuments()) {
          Alert.error('Por favor, envie todos os documentos obrigatórios.');
          return;
        }
      }

      if (this.paymentMethod.is_credit_card) {
        let modal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#modalAddress'));
        modal.toggle();
      }

      Swal.fire({
        title: 'Agendando',
        text: 'Por favor, aguarde',
        allowOutsideClick: false,
      });
      Swal.showLoading();

      this.$store.dispatch('professionalProfile/scheduleAppointment', {
        creditCard: this.creditCard,
        creditCardTokenId: this.selectedCreditCardId,
        saveCard: this.saveCard,
        cardNickname: this.cardNickname,
        userAddress: this.userAddress,
        files: this.uploadedDocuments
      }).then(() => {
        this.creditCard = null;
        this.selectedCreditCardId = null;
        this.saveCard = false;
        this.cardNickname = '';
        this.uploadedDocuments = [];
        if (this.paymentMethod?.is_pix) {
          this.$router.push(profileTo(this, 'pix'));
        } else {
          this.$router.push(profileTo(this, 'scheduled'));
        }

        Swal.close();
      }).catch(e => {
        Swal.close();
        const response = e.response;
        let errorMessage = response?.data?.message || 'Falha ao agendar consulta';
        
        if (response?.status === 422 && response.data?.errors) {
          const errorMessages = Object.values(response.data.errors).flat();
          errorMessage = errorMessages.length > 0 ? errorMessages.join('<br>') : errorMessage;
        } else if (typeof response?.data === 'string') {
          errorMessage = response.data;
        }
        
        this.msgErrorSchedule = errorMessage;
        Swal.fire({
          icon: 'error',
          title: 'Falha ao agendar consulta',
          html: errorMessage,
        });
      });
    },
  }
}
</script>

<style scoped>

</style>
